var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.705 20.218c1.939 1.26 4.46.97 6.107-.678l.68-.679c.678-.678.678-1.648 0-2.326l-2.91-2.909c-.678-.678-1.647-.678-2.326 0-.678.68-1.648.68-2.326 0L8.277 8.974c-.68-.678-.68-1.648 0-2.326.775-.582.775-1.551.096-2.23L5.465 1.51C4.787.83 3.817.83 3.14 1.509l-.679.679C.812 3.836.521 6.356 1.781 8.295c2.715 4.168 7.756 9.21 11.924 11.923z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgPhone2;